import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm, message } from 'antd';
import { useDispatch } from 'react-redux';
import { remove } from '@src/store/tempDashboard/actions';

function ActionCell({ id }) {

  const dispatch = useDispatch();

  const confirm = (e: React.MouseEvent<HTMLElement>) => {
    dispatch(remove(id, false));
    message.success(`Removed temp dashboard successfully`);
  };

  return (
    <div>
      <Popconfirm
        title="Delete temp dashboard"
        description="Are you sure to delete this dashboard?"
        onConfirm={confirm}
        okText="Yes"
        cancelText="No"
      >
        <DeleteOutlined />
      </Popconfirm>
    </div>
  );
}

export default ActionCell;
